import { Grid2, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../../../hooks/useTranslate";
import IconCard from "../../../components/IconCard";
import IconStudentHub from "../../../assets/images/navigation/student-hub.svg?react";
import IconCommunity from "../../../assets/images/navigation/community.svg?react";
import IconAcademic from "../../../assets/images/navigation/academic.svg?react";
import Stage1 from "../../../assets/images/images/stage1.png";
import Stage2 from "../../../assets/images/images/stage2.png";
import Stage3 from "../../../assets/images/images/stage3.png";
import Stage4 from "../../../assets/images/images/stage4.png";
import GSTUpper from "../../../assets/images/images/GST-SEA-upper.jpg";
import GSTLower from "../../../assets/images/images/GST-SEA-lower.jpg";
import { useStudents } from "../../../context/students";
import NeedSupportBox from "./components/NeedSupportBox";
import { useOmnichannelWidget } from "../../../hooks/useOmnichannelWidget";
import useStatuses from "../../../context/status/useStatuses";
import { ISAMS_LINK } from "../../../services/isamsConfig";
import "./Home.css";

const links = {
    ks2: "https://sway.cloud.microsoft/jRiNG4CGEgHHqZeZ",
    ks3: "https://sway.cloud.microsoft/DtTjLZaKarHNi8r8",
    ks4: "https://sway.cloud.microsoft/yVMZBlSaBOwEFqrt?ref=Link",
    ks5: "https://sway.cloud.microsoft/7CiAbp44skKtFMge",
    gstSeaUpper: "https://sway.cloud.microsoft/KdhPyso3TIBXbZsW",
    gstSeaLower: "https://sway.cloud.microsoft/AKI4mekRVJNEXAo6",
};

const Home = () => {
    const { t } = useTranslate();
    useOmnichannelWidget();
    const navigate = useNavigate();
    const { activeStudentId } = useStudents();
    const { studentIsamsId } = useStatuses();

    return (
        <div className="page-content">
            <div className="student-head-section student-head-section--short" />
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                    <Typography variant="h1" className="text-white">
                        {t("home.title")}
                    </Typography>
                </Grid2>
            </Grid2>
            <NeedSupportBox className="mt-8" />
            <Grid2 container spacing={4} className="mt-12">
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <IconCard
                        icon={<IconStudentHub />}
                    >
                        <div className="w-full flex flex-wrap align-center justify-between gap-1">
                            <Typography
                                variant="h4"
                                className="icon-card__title"
                            >
                                {t("home.viewStudentTimetable")}
                            </Typography>
                            <Button
                                className="button-small button-primary"
                                href={`https://${ISAMS_LINK}/#/school-profile/school-timetable`}
                                target="_blank"
                            >
                                {t("button.view")}
                            </Button>
                        </div>
                    </IconCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <IconCard
                        icon={<IconAcademic />}
                    >
                        <div className="w-full flex flex-wrap align-center justify-between gap-1">
                            <Typography variant="h4" className="icon-card__title">{t("home.viewAcademics")}</Typography>
                            <Button
                                className="button-small button-primary"
                                onClick={() => navigate(`/academic/${activeStudentId}`)}
                            >
                                {t("button.view")}
                            </Button>
                        </div>
                    </IconCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <IconCard
                        icon={<IconCommunity />}
                    >
                        <div className="w-full flex flex-wrap align-center justify-between gap-1">
                            <Typography variant="h4" className="icon-card__title">{t("home.viewCommunity")}</Typography>
                            <Button
                                className="button-small button-primary"
                                onClick={() => navigate(`/community/${activeStudentId}`)}
                            >
                                {t("button.view")}
                            </Button>
                        </div>
                    </IconCard>
                </Grid2>
            </Grid2>
            <Typography variant="h2" component="h3" className="mt-12">
                {t("home.schoolNewsBoard")}
            </Typography>
            <Grid2 container spacing={2} className="mt-4">
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <a href={links.ks2} target="_blank" className="stage-box" rel="noreferrer">
                        <img alt="ket stage 2" src={Stage1} className="stage-box__bg" />
                        <div className="stage-box__inner">
                            <span className="stage-box__badge">{t("home.keyStage2")}</span>
                            <Typography variant="h5" className="stage-box__title">
                                {t("home.keyStage2Title")}
                            </Typography>
                        </div>
                    </a>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <a href={links.ks3} target="_blank" className="stage-box" rel="noreferrer">
                        <img alt="ket stage 3" src={Stage2} className="stage-box__bg" />
                        <div className="stage-box__inner">
                            <span className="stage-box__badge">{t("home.keyStage3")}</span>
                            <Typography variant="h5" className="stage-box__title">
                                {t("home.keyStage3Title")}
                            </Typography>
                        </div>
                    </a>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <a href={links.gstSeaLower} target="_blank" className="stage-box" rel="noreferrer">
                        <img alt="GST/SEA LOWER" src={GSTLower} className="stage-box__bg" />
                        <div className="stage-box__inner">
                            <span className="stage-box__badge">{t("home.gstSeaLower")}</span>
                            <Typography variant="h5" className="stage-box__title">
                                {t("home.gstSeaLowerTitle")}
                            </Typography>
                        </div>
                    </a>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <a href={links.ks4} target="_blank" className="stage-box" rel="noreferrer">
                        <img alt="ket stage 4" src={Stage4} className="stage-box__bg" />
                        <div className="stage-box__inner">
                            <span className="stage-box__badge">{t("home.keyStage4")}</span>
                            <Typography variant="h5" className="stage-box__title">
                                {t("home.keyStage4Title")}
                            </Typography>
                        </div>
                    </a>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <a href={links.ks5} target="_blank" className="stage-box" rel="noreferrer">
                        <img alt="ket stage 5" src={Stage3} className="stage-box__bg" />
                        <div className="stage-box__inner">
                            <span className="stage-box__badge">{t("home.keyStage5")}</span>
                            <Typography variant="h5" className="stage-box__title">
                                {t("home.keyStage5Title")}
                            </Typography>
                        </div>
                    </a>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <a href={links.gstSeaUpper} target="_blank" className="stage-box" rel="noreferrer">
                        <img alt="GST/SEA UPPER" src={GSTUpper} className="stage-box__bg" />
                        <div className="stage-box__inner">
                            <span className="stage-box__badge">{t("home.gstSeaUpper")}</span>
                            <Typography variant="h5" className="stage-box__title">
                                {t("home.gstSeaUpperTitle")}
                            </Typography>
                        </div>
                    </a>
                </Grid2>
            </Grid2>
        </div>
    );
};

export default Home;
